import { Component, OnInit } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { filter, map, shareReplay, switchMap } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";

import { DffCookieConsentService } from "../dff-cookie-consent";
import { DffCookieConsentCookie } from "../dff-cookie-consent/dff-cookie-consent-cookie.model";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { DffCookieConsentCookieListComponent } from "../dff-cookie-consent-cookie-list/dff-cookie-consent-cookie-list.component";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { mapCookiesWithDescription, applyDescriptionsByName, DffCookieConsentCookieWithDescription } from "../cookie-mapper.utils";

@Component({
    selector: "dff-cookie-consent-dialog",
    templateUrl: "./dff-cookie-consent-dialog.component.html",
    styleUrls: ["./dff-cookie-consent-dialog.component.scss"],
    imports: [
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        MatTabGroup,
        MatTab,
        DffCookieConsentCookieListComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatProgressSpinner,
        AsyncPipe
    ]
})
export class DffCookieConsentDialogComponent implements OnInit {
    public side = "consent";
    public vm$: Observable<ViewModel>;

    constructor(
        private readonly cookieConsentService: DffCookieConsentService,
        private readonly indstillingerObserver: UmbracoIndstillingerObserver,
        private readonly umbracoHttpClient: UmbracoHttpClient
    ) {}

    public ngOnInit(): void {
        this.vm$ = this.indstillingerObserver.valueChanges.pipe(
            map((i) => (i.forsyningWeb && i.forsyningWeb.nodeId) || (i.aktuelEforsyning && i.aktuelEforsyning.nodeId)),
            filter((nodeId) => !!nodeId),
            switchMap((nodeId) =>
                combineLatest([
                    this.umbracoHttpClient.get<string>(`GetCookieConsentText?nodeId=${nodeId}`),
                    this.umbracoHttpClient.get<DffCookieConsentCookie[]>(`GetCookies?nodeId=${nodeId}`)
                ])
            ),
            map(([html, cookies]) => {
                const addWithDescription = mapCookiesWithDescription(cookies);
                const mapDescription = applyDescriptionsByName(addWithDescription);
                return {
                    html,
                    cookies: {
                        mandatory: mapDescription.filter((c) => c.mandatory),
                        optional: mapDescription.filter((c) => !c.mandatory)
                    }
                };
            }),
            shareReplay(1)
        );
    }

    public onGotoReadMoreClick(event: Event): void {
        event.preventDefault();
        this.side = "laes-mere";
    }

    public onGotoConsentClick(event: Event): void {
        event.preventDefault();
        this.side = "consent";
    }

    public onConsentApproveClick(): void {
        this.cookieConsentService.approveCookies();
    }

    public onConsentRejectClick(): void {
        this.cookieConsentService.rejectCookies();
    }
}

interface ViewModel {
    html: string;
    cookies: {
        optional: DffCookieConsentCookieWithDescription[];
        mandatory: DffCookieConsentCookieWithDescription[];
    };
}
